import { environment } from "@env/environment";

/**
 * 
 * Configures the reCaptcha behavior based on environment settings and URL parameters.
 * This function will disable reCaptcha under specific conditions. When
 * an automated test flag is set in the environment and a URL parameter is present
 * that indicates skipping the reCaptcha validation.
 *
 * @param {boolean} envStateForCurrentTypeOfLogin - The current login state as determined by the environment configuration.
 * @param {string} [urlParamForSkippingReCaptcha] - Optional URL parameter used to skip reCaptcha validation.
 * If this matches the `captchaUrlKey` from the environment configuration and automated tests are enabled,
 * reCaptcha will be disabled.
 * 
 * @returns {boolean} - Returns `false` if reCaptcha should be skipped (based on URL parameter and environment flag),
 * or the value of `envStateForCurrentTypeOfLogin` otherwise. This indicates whether reCaptcha is enabled (`true`) or disabled (`false`).
 * 
 */

export function configureReCaptchaWithEnv(envStateForCurrentTypeOfLogin: boolean, urlParamForSkippingReCaptcha?: string | undefined) {
    
    if (urlParamForSkippingReCaptcha && environment.reCaptcha.reCaptchaSkip) {
        return false;
    }

    return envStateForCurrentTypeOfLogin;
}